<template>
  <div>
    <NavBar/>
    <section id="services" class="section is-medium" style="background-color: #EFF4F7;">
      <div class="container">
        <h1 v-html="$t('privacyPolicy_main_title')" class="title is-1 is-spaced has-text-grey"></h1>
        <h2 v-html="$t('privacyPolicy_title')" class="title is-2"></h2>
        <p v-html="$t('privacyPolicy_text')" style="margin-bottom: 25px;"></p>
        <h3 v-html="$t('privacyPolicy_data_acquisition_title')" class="title is-3"></h3>
        <p v-html="$t('privacyPolicy_data_acquisition_text')" style="margin-bottom: 25px;"></p>
        <h4 v-html="$t('privacyPolicy_right_of_appeal_title')" class="title is-4"></h4>
        <p v-html="$t('privacyPolicy_right_of_appeal_text')" style="margin-bottom: 25px;"></p>
        <h4 v-html="$t('privacyPolicy_contact_form_title')" class="title is-4"></h4>
        <p v-html="$t('privacyPolicy_contact_form_text')" style="margin-bottom: 25px;"></p>
        <h3 v-html="$t('privacyPolicy_cookies_title')" class="title is-3"></h3>
        <p v-html="$t('privacyPolicy_cookies_text')" style="margin-bottom: 25px;"></p>
        <h4 v-html="$t('privacyPolicy_google_analytics_title')" class="title is-4"></h4>
        <p v-html="$t('privacyPolicy_google_analytics_text')" style="margin-bottom: 25px;"></p>
      </div>
    </section>
    <Footer/>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'PrivacyPolicy',
  components: {
    NavBar,
    Footer,
  },
};
</script>
